import { api } from "./api";

function isNotFoundError(err) {
  const msg = String(err?.message || "").toLowerCase();
  return msg.includes("not found") || msg.includes("404");
}

function buildResumenPayload(filtros) {
  return {
    desde: filtros?.fechaDesde,
    hasta: filtros?.fechaHasta,
    usuario_id: filtros?.usuarioId ?? null,
    usuario_ids: filtros?.usuarioIds ?? null,
  };
}

function buildLegacyExportPayload(filtros, formato) {
  return {
    desde: filtros?.fechaDesde,
    hasta: filtros?.fechaHasta,
    usuario_id: filtros?.usuarioId ?? null,
    usuario_ids: filtros?.usuarioIds ?? null,
    formato,
  };
}

export async function fetchInformeResumen(payload, token, signal) {
  return api.post("/informes/resumen", payload, token, {}, signal);
}

export async function getKPIs(filtros, token, signal) {
  try {
    return await api.post(
      "/informes/kpis",
      {
        filtros: {
          fechaDesde: filtros?.fechaDesde,
          fechaHasta: filtros?.fechaHasta,
          usuarioId: filtros?.usuarioId ?? null,
          usuarioIds: filtros?.usuarioIds ?? null,
        },
      },
      token,
      {},
      signal
    );
  } catch (err) {
    if (!isNotFoundError(err)) throw err;
    const resumenPayload = buildResumenPayload(filtros);
    return fetchInformeResumen(resumenPayload, token, signal);
  }
}

export async function exportarInforme(tipoInforme, formato, filtros, token, signal) {
  try {
    return await api.download(
      "/informes/export",
      "POST",
      {
        tipoInforme,
        formato,
        filtros: {
          fechaDesde: filtros?.fechaDesde,
          fechaHasta: filtros?.fechaHasta,
          usuarioId: filtros?.usuarioId ?? null,
          usuarioIds: filtros?.usuarioIds ?? null,
        },
      },
      token,
      {},
      signal
    );
  } catch (err) {
    if (!isNotFoundError(err)) throw err;
    const fmt = (formato || "").toLowerCase() === "generate" ? "pdf" : formato;
    const legacyPayload = buildLegacyExportPayload(filtros, fmt);
    if (tipoInforme === "registro_legal") {
      return exportRegistroInforme(legacyPayload, token, signal);
    }
    if (tipoInforme === "rrhh") {
      return exportRRHHInforme(legacyPayload, token, signal);
    }
    if (tipoInforme === "ausencias") {
      return exportAuditoriaInforme(legacyPayload, token, signal);
    }
    throw err;
  }
}

export async function exportRegistroInforme(payload, token, signal) {
  return api.download("/informes/registro/export", "POST", payload, token, {}, signal);
}

export async function exportRRHHInforme(payload, token, signal) {
  return api.download("/informes/rrhh/export", "POST", payload, token, {}, signal);
}

export async function exportAuditoriaInforme(payload, token, signal) {
  return api.download("/informes/auditoria/export", "POST", payload, token, {}, signal);
}

export function parseFilenameFromHeader(res) {
  const cd = res?.headers?.get?.("content-disposition") || "";
  const match = /filename\*=UTF-8''([^;]+)|filename="?([^;\"]+)"?/i.exec(cd);
  const name = match?.[1] || match?.[2];
  return name ? decodeURIComponent(name) : null;
}

export async function downloadBlob(res, fallbackName) {
  const blob = await res.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fallbackName || "informe";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
